import { RequestsFormStore } from "@/services/stores/types";
import { StateCreator } from "zustand/esm";

export const requestFromStore: StateCreator<RequestsFormStore> = set => ({
  isAcknowledged: false,
  setIsAcknowledged: (isAcknowledged: boolean) => {
    return set(state => ({ ...state, isAcknowledged: isAcknowledged }));
  },
  documentsInitialized: false,
  setDocumentsInitialized: (documentsInitialized: boolean) => {
    return set(state => ({
      ...state,
      documentsInitialized,
    }));
  },
  requestFormData: null,
  setRequestFormData: (dropdownId, value) => {
    return set(state => {
      return {
        ...state,
        requestFormData: {
          ...state.requestFormData,
          [dropdownId]: value,
        },
      };
    });
  },
  removeRequestFormData: dropdownId =>
    set(state => {
      if (
        state.requestFormData?.[
          dropdownId as keyof typeof state.requestFormData
        ]
      ) {
        delete state.requestFormData?.[
          dropdownId as keyof typeof state.requestFormData
        ];
      }

      return state;
    }),
  setRequestFormDataDocs: (docId, data) => {
    return set(state => {
      return {
        ...state,
        requestFormData: {
          ...state.requestFormData,
          RequestDocuments: {
            ...state.requestFormData?.RequestDocuments,
            [docId]: data,
          },
        },
      };
    });
  },
  removeRequestFormDataDocs: docId => {
    return set(state => {
      if (state.requestFormData?.RequestDocuments?.[docId]) {
        delete state.requestFormData?.RequestDocuments?.[docId];
      }

      return state;
    });
  },
  resetRequestFormDataDocs: () =>
    set(state => {
      delete state.requestFormData?.RequestDocuments;

      return state;
    }),
  resetRequestFormDataPersonnels: () =>
    set(state => {
      delete state.requestFormData?.Personnels;

      return state;
    }),
  resetRequestFormData: () =>
    set(state => {
      return {
        ...state,
        requestFormData: null,
      };
    }),
  resetRequestFormDataNumbers: () =>
    set(state => {
      delete state.requestFormData?.NumberOfPersonnel;

      return state;
    }),
});
